import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import Layout from '../../components/layout/Layout';

const TermsOfService: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleBackClick = () => {
    if (location.state?.returnTo) {
      navigate(location.state.returnTo, { 
        state: { formData: location.state.formData }
      });
    } else {
      navigate(-1);
    }
  };

  return (
    <Layout>
      <MainContainer>
        <SloganSection>
          <SloganTitle>대한민국의학한림원 × 투비닥터 의료 AI 캠퍼스 이용약관</SloganTitle>
        </SloganSection>
        
        <ContentContainer>
          <TermsContent>
            <Section>
              <SectionTitle>제1조 (목적)</SectionTitle>
              <SectionContent>
                본 약관은 투비닥터가 제공하는 인공지능 및 의료 관련 온라인 강의 및 커뮤니티 플랫폼(이하 "서비스")의 이용과 관련하여 투비닥터와 회원 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
              </SectionContent>
            </Section>

            <Section>
              <SectionTitle>제2조 (용어의 정의)</SectionTitle>
              <SectionContent>
                1. "서비스"란 투비닥터가 제공하는 온라인 강의, 전문가 온라인 커피챗, 커뮤니티, 게시판 등 일체의 온라인 교육 콘텐츠 및 기능을 의미합니다.
                {'\n'}2. "서비스 제공자"란 본 약관을 통해 서비스를 제공하는 투비닥터를 의미합니다.
                {'\n'}3. "회원"이란 본 약관에 동의하고 투비닥터와 이용계약을 체결하여 서비스를 이용하는 자를 의미합니다.
                {'\n'}4. "ID"는 회원의 식별과 서비스 이용을 위하여 회원이 설정하고 투비닥터가 승인하는 문자 또는 숫자의 조합을 말합니다.
                {'\n'}5. "비밀번호"는 회원의 본인 여부를 확인하고 회원의 권익 보호를 위해 회원이 설정한 문자 및 숫자의 조합을 말합니다.
                {'\n'}6. "콘텐츠"는 서비스 내에서 제공되는 동영상, 텍스트, 이미지, 음성 등 일체의 정보 및 자료를 의미합니다.
              </SectionContent>
            </Section>

            <Section>
              <SectionTitle>제3조 (약관의 게시와 개정)</SectionTitle>
              <SectionContent>
                1. 투비닥터는 본 약관의 내용을 회원이 쉽게 확인할 수 있도록 서비스 초기화면 또는 연결화면에 게시합니다.
                {'\n'}2. 투비닥터는 관련 법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있으며, 개정 시 적용일자 및 개정사유를 명시하여 현행 약관과 함께 적용일자 7일 전부터 공지합니다. 단, 회원에게 불리한 변경은 최소 30일 전 공지합니다. 공지는 서비스 내 공지사항 게시판 또는 회원이 제공한 이메일 주소를 통해 이루어집니다.
              </SectionContent>
            </Section>

            <Section>
              <SectionTitle>제4조 (이용계약의 성립)</SectionTitle>
              <SectionContent>
                1. 이용계약은 회원이 본 약관에 동의하고, 투비닥터가 정한 절차에 따라 이용신청을 하며 투비닥터가 이를 승낙함으로써 성립됩니다.
                {'\n'}2. 투비닥터는 다음 각 호의 어느 하나에 해당하는 신청에 대하여는 승낙을 거절하거나 사후에 이용계약을 해지할 수 있습니다.
                {'\n'}   가. 실명이 아니거나 타인의 명의를 도용한 경우
                {'\n'}   나. 허위 정보를 기재하거나, 필수사항을 누락한 경우
                {'\n'}   다. 만 14세 미만의 아동이 법정대리인의 동의 없이 신청한 경우
              </SectionContent>
            </Section>

            <Section>
              <SectionTitle>제5조 (서비스의 제공 및 변경)</SectionTitle>
              <SectionContent>
                1. 투비닥터는 회원에게 온라인 강의 수강, 전문가 커피챗, 커뮤니티 기능 등을 제공합니다.
                {'\n'}2. 투비닥터는 서비스 개선 또는 기술적 필요에 따라 서비스의 전부 또는 일부를 변경할 수 있으며, 이 경우 사전에 회원에게 서비스 내 공지사항 게시판 또는 회원이 제공한 이메일 주소를 통해 공지합니다.
              </SectionContent>
            </Section>

            <Section>
              <SectionTitle>제6조 (서비스의 중단)</SectionTitle>
              <SectionContent>
                1. 투비닥터는 서비스 설비의 보수, 교체, 점검, 통신장애 등 불가피한 사유가 발생한 경우 서비스 제공을 일시 중단할 수 있습니다.
                {'\n'}2. 투비닥터는 제1항의 사유로 서비스 제공이 중단되는 경우 사전에 서비스 내 공지사항 게시판 또는 회원이 제공한 이메일 주소를 통해 공지하며, 불가피한 경우 사후에 공지할 수 있습니다.
              </SectionContent>
            </Section>

            <Section>
              <SectionTitle>제7조 (회원의 의무)</SectionTitle>
              <SectionContent>
                1. 회원은 다음 행위를 하여서는 안 됩니다.
                {'\n'}   가. 타인의 정보 도용
                {'\n'}   나. 투비닥터 또는 제3자의 저작권 등 권리 침해
                {'\n'}   다. 서비스를 이용하여 불법행위 또는 범죄행위
                {'\n'}   라. 허위 사실 유포 또는 서비스의 정상적 운영 방해
                {'\n'}2. 회원은 투비닥터의 운영방침 및 관련 법령을 준수해야 합니다.
              </SectionContent>
            </Section>

            <Section>
              <SectionTitle>제8조 (서비스 제공자의 의무)</SectionTitle>
              <SectionContent>
                1. 투비닥터는 법령과 본 약관이 금지하거나 공서양속에 반하지 않는 한 계속적이고 안정적인 서비스를 제공하기 위해 노력합니다.
                {'\n'}2. 투비닥터는 회원의 개인정보 보호를 위해 개인정보처리방침을 공시하고 준수합니다.
              </SectionContent>
            </Section>

            <Section>
              <SectionTitle>제9조 (콘텐츠의 이용 및 제한)</SectionTitle>
              <SectionContent>
                1. 회원은 투비닥터가 제공하는 콘텐츠를 개인적인 학습 목적 범위 내에서만 이용할 수 있으며, 이를 무단 복제, 배포, 전송, 공개 게시하는 등의 행위를 하여서는 안 됩니다.
                {'\n'}2. 투비닥터는 콘텐츠 저작권 보호 및 서비스 질 향상을 위해 필요한 경우 콘텐츠의 제공을 변경, 제한 또는 중단할 수 있습니다.
                {'\n'}3. 회원이 위 1항의 무단 복제, 배포, 전송, 공개 게시하는 등의 행위를 한 경우 투비닥터는 회원에게 위 행위로 인하여 발생한 손해배상을 청구할 수 있습니다.
              </SectionContent>
            </Section>

            <Section>
              <SectionTitle>제10조 (결제, 환불 및 청약철회)</SectionTitle>
              <SectionContent>
                1. 유료 서비스 이용을 위해 회원은 투비닥터가 제공하는 결제 수단을 통해 요금을 납부해야 하며, 결제 정보는 정확해야 합니다.
                {'\n'}2. 회원은 관련 법령에 따라 일정 기간 내에 청약을 철회할 수 있으며, 디지털 콘텐츠의 경우 회원이 유료 콘텐츠의 재생 또는 다운로드 버튼을 클릭하는 등 콘텐츠 제공이 개시된 경우 청약철회가 불가능하다는 점에 대하여 별도의 팝업창 등을 통해 명확히 고지하고 동의를 얻은 때에는 청약철회가 제한됩니다.
                {'\n'}3. 투비닥터는 환불 및 철회 기준을 별도의 환불정책 페이지에 고지하며, 그 절차에 따라 처리합니다.
              </SectionContent>
            </Section>

            <Section>
              <SectionTitle>제11조 (게시물의 관리)</SectionTitle>
              <SectionContent>
                1. 투비닥터는 회원이 작성한 게시물이 다음 각 호에 해당하는 경우 사전통지 없이 삭제하거나 열람을 제한할 수 있습니다.
                {'\n'}   가. 불법적, 음란하거나 명예훼손적인 내용
                {'\n'}   나. 광고 또는 영리를 목적으로 하는 경우
                {'\n'}   다. 타인의 권리를 침해하거나 분쟁을 유발하는 경우
                {'\n'}2. 회원의 위 행위로 인하여 투비닥터에 대한 손해가 발생한 경우 투비닥터는 해당 행위에 대한 손해배상을 청구할 수 있습니다.
              </SectionContent>
            </Section>

            <Section>
              <SectionTitle>제12조 (면책조항)</SectionTitle>
              <SectionContent>
                1. 투비닥터는 투비닥터의 고의가 아닌 천재지변, 불가항력, 회원의 귀책사유로 인한 서비스 이용 장애에 대해 책임을 지지 않습니다.
                {'\n'}2. 투비닥터는 회원이 서비스 이용을 통해 기대하는 수익, 학습 성과 등에 대하여 보장하지 않습니다.
              </SectionContent>
            </Section>

            <Section>
              <SectionTitle>제13조 (분쟁 해결 및 관할)</SectionTitle>
              <SectionContent>
                1. 투비닥터와 회원 간 발생한 분쟁에 대해 원만히 해결되지 않을 경우 관할 법원은 투비닥터의 본사 소재지를 관할하는 법원으로 합니다.
              </SectionContent>
            </Section>

            <Section>
              <SectionTitle>부칙</SectionTitle>
              <SectionContent>
                본 약관은 2025년 10월 1일부터 시행합니다.
              </SectionContent>
            </Section>
          </TermsContent>
        </ContentContainer>
      </MainContainer>
    </Layout>
  );
};

const MainContainer = styled.main`
  max-width: ${({ theme }) => theme.layout.containerWidth};
  margin: 0 auto;
  padding: 64px 80px;
  min-height: 100vh;
  
  @media (max-width: 1024px) {
    padding: 64px 40px;
  }
  
  @media (max-width: 768px) {
    padding: 64px 20px;
  }
`;

const SloganSection = styled.div`
  margin-bottom: 48px;
`;

const SloganTitle = styled.h1`
  font-family: 'Pretendard JP', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 32px;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: -1.13px;
  color: #171719;
  margin: 0;
  text-align: left;
`;

const ContentContainer = styled.div`
  width: 100%;
`;

const TermsContent = styled.div`
  background: transparent;
`;

const Section = styled.div`
  margin-bottom: 32px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const SectionTitle = styled.h2`
  font-family: 'Pretendard JP', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.4;
  color: #171719;
  margin: 0 0 12px 0;
`;

const SectionContent = styled.p`
  font-family: 'Pretendard JP', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.6;
  color: rgba(23, 23, 25, 0.88);
  margin: 0;
  white-space: pre-line;
`;

export default TermsOfService;